<template>
  <PhonePreviewLayout :settings="settings">
    <template #header>
      <div
        class="screen-header"
        :style="{ background: layoutBgColor }"
      >
        <span>Топ зимы</span>
      </div>
    </template>
    <template #content>
      <PhonePreviewFilters :filterBtns="filterBtns" :settings="settings" />
      <div class="screen-sport">
        <PhonePreviewSportBlock :settings="settings" />
        <PhonePreviewSportBlock :settings="settings" />
      </div>
    </template>
  </PhonePreviewLayout>
</template>
<script>
import PhonePreviewLayout from '@/views/apps/custom-pages/components/phone/parts/PhonePreviewLayout.vue'
import PhonePreviewSportBlock from '@/views/apps/custom-pages/components/phone/parts/PhonePreviewSportBlock.vue'
import PhonePreviewFilters from '@/views/apps/custom-pages/components/phone/parts/PhonePreviewFilters.vue'

import { mixWithBase } from '@/services/utils/custom-pages'

export default {
  components: {
    PhonePreviewLayout,
    PhonePreviewSportBlock,
    PhonePreviewFilters,
  },
  props: {
    settings: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      filterBtns: [
        {
          text: '',
          icon: 'close',
          iconPlacement: 'start',
          active: false,
        },
        {
          text: 'Пример 1',
          icon: 'forward',
          iconPlacement: 'start',
          active: true,
        },
        {
          text: 'Пример 2',
          icon: 'caret-down',
          iconPlacement: 'end',
          active: false,
        },
        {
          text: 'Пример 3',
          icon: 'mail',
          iconPlacement: 'start',
          active: false,
        },
      ],
    }
  },
  computed: {
    layoutBgColor() {
      return this.settings?.main?.fill === 'gradient'
        ? mixWithBase(this.settings?.main?.mainColor, this.settings?.schema)
        : this.settings?.main?.mainColor
    },
  },
}
</script>
<style scoped lang="scss">
.screen-header {
  font-size: 12px;
  line-height: 15px;
  font-weight: 700;
  padding-top: 38px;
  padding-left: 32px;
  padding-bottom: 6px;
}
</style>
